import React from "react";
import "../styles/privacyPolicy.css"; // Optional CSS file for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> December 13, 2024</p>

      <p>
        At <strong>Ukab Pakshi</strong>, we respect your privacy and are committed to protecting
        the personal information you share with us. This Privacy Policy outlines how we
        collect, use, and protect your data when you use our services.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Account Information:</strong> When you sign up for an account, we collect
          your name, email address, and username.
        </li>
        <li>
          <strong>Profile Information:</strong> You may choose to provide additional information
          such as a profile picture or bio.
        </li>
        <li>
          <strong>Post Information:</strong> We collect the content you create, including blog
          posts, comments, and any media (images or videos) associated with your posts.
        </li>
        <li>
          <strong>Usage Data:</strong> We collect data on how you use our app, including your
          interactions with content, pages you visit, and time spent on each page.
        </li>
        <li>
          <strong>Device Information:</strong> We collect data about the device you use to
          access the app, such as device type, operating system, and browser type.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Provide and manage your account, including authentication and security.</li>
        <li>
          Enable features such as creating and viewing posts, commenting, and liking
          content.
        </li>
        <li>Improve the functionality and user experience of the app.</li>
        <li>Send you updates, notifications, or marketing messages (if you have opted in).</li>
        <li>Monitor app usage for analytics and performance improvements.</li>
      </ul>

      <h2>3. Data Sharing and Third-Party Services</h2>
      <p>
        We do not sell your personal information to third parties. However, we may share
        your data with trusted third-party service providers who help us operate the app and
        provide services such as authentication and analytics. These services include:
      </p>
      <ul>
        <li>
          <strong>Firebase:</strong> For authentication, database management (Firestore), and
          other services. Firebase may collect data as outlined in their own privacy policy.
        </li>
        <li>
          <strong>Google Analytics:</strong> To track app usage and gather insights into how
          users interact with the app.
        </li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>
        We retain your personal data only as long as necessary to provide our services or as
        required by law. You can delete your account at any time, which will remove your
        personal data from our system, except where retention is required by law.
      </p>

      <h2>5. Security</h2>
      <p>
        We take appropriate measures to secure your data, including encryption and secure
        data storage, to protect against unauthorized access, disclosure, or alteration.
      </p>

      <h2>6. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access and update your personal information.</li>
        <li>Request the deletion of your account and data.</li>
        <li>Object to or restrict the processing of your personal information.</li>
        <li>Withdraw your consent to marketing communications.</li>
      </ul>
      <p>To exercise these rights, please contact us at <strong>[Your Contact Email]</strong>.</p>

      <h2>7. Cookies</h2>
      <p>
        We may use cookies to enhance your experience, personalize content, and analyze site
        traffic. You can disable cookies in your browser settings, but this may affect the
        functionality of the app.
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. If we make any material
        changes, we will notify you by updating the "Effective Date" at the top of this page
        or by sending you a notice via email.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us
        at:
      </p>
      <address>
        <strong>Sumit Kumar Karari</strong>
        <br />
        Email: <a href="mailto:sumitkarari4@gmail.com">sumitkarari4@gmail.com</a>
        <br />
        Website: <a href="http://www.ukabpakshi.com" target="_blank" rel="noopener noreferrer">www.ukabpakshi.com</a>
      </address>
    </div>
  );
};

export default PrivacyPolicy;
